export default __webpack_public_path__ + "static/media/mz.4e2241e2.svg";